// @ts-nocheck
class WIvariantslider extends HTMLElement {
  constructor() {
    super();
    this.custCal = false;
    this.selectedVariantId = null;
    this.selectedIsStatic = false;
    this.selectedSize = null;
    this.selectedPrice = null;
  }

  connectedCallback() {
    this._cacheElements();
    this.selectingVariant();
    this.setupAtcButton();
    this.openCustomSizeSlider();
    this.closeCustomSizeSlider();
    this.setupAndersForm();
    this.openVarSlider();
    this.closeVarSlider();
  }

  _cacheElements() {
    this.varOpen = document.querySelectorAll('.WI_variantOpner');
    this.varClose = this.querySelector('#WI_variantClose');
    this.varMain = this;
    this.varIn = this.querySelector('.WI_cal_in');
    this.priceEl = this.querySelector('.WI_cal_in_footer_price');
    this.atcBtn = this.querySelector('.WI_cal_in_footer_atc');
  }

  selectingVariant() {
    this.addEventListener('change', (e) => {
      const input = e.target.closest('input[type="radio"]');
      if (!input) return;

      const isStatic = input.getAttribute('data-static') === 'true';
      const price    = input.getAttribute('data-var');
      const size     = input.getAttribute('data-size');

      this.selectedIsStatic  = isStatic;
      this.selectedVariantId = isStatic ? null : input.value;
      this.selectedSize  = isStatic ? size : input.value;
      this.selectedPrice = price;

      // Update footer price
      if (this.priceEl) {
        const formatted = this._formatMoney(parseInt(price));
        this.priceEl.innerHTML = isStatic ? 'Vanaf ' + formatted : formatted;
      }

      // Update button text
      if (this.atcBtn) {
        const span = this.atcBtn.querySelector('span');
        if (span) span.textContent = isStatic ? 'Aanvragen' : this.atcBtn.dataset.defaultText || 'Toevoegen aan winkelwagen';
        else this.atcBtn.firstChild.textContent = isStatic ? 'Aanvragen' : this.atcBtn.dataset.defaultText || 'Toevoegen aan winkelwagen';
      }
    });
  }

  setupAtcButton() {
    if (!this.atcBtn) return;

    // Store original button text
    this.atcBtn.dataset.defaultText = this.atcBtn.textContent.trim();

    this.atcBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      const spinner = this.querySelector('.WI_loadingSpiner');
      if (spinner) spinner.style.display = 'flex';

      if (this.custCal) {
        const w = this.querySelector('#WI_cw')?.value?.trim();
        const activeShapeBtn = this.querySelector('#WI_custom_shape_row .WI_cs_active');
        const shapeKey = activeShapeBtn?.dataset.shape || 'rechthoek';
        const h = shapeKey === 'rond' ? w : this.querySelector('#WI_ch')?.value?.trim();
        const shapeLabel = shapeKey === 'anders'
          ? (this.querySelector('#WI_custom_shape_desc')?.value?.trim() || 'Andere')
          : (shapeKey.charAt(0).toUpperCase() + shapeKey.slice(1));
        const result = this._calcCustomPrice(w, h, shapeKey);
        const variantId = this.querySelector('.WI_variant_group_customCal')?.dataset.variantId;
        if (!variantId || !result) { if (spinner) spinner.style.display = 'none'; return; }
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1, properties: { 'Vorm': shapeLabel, 'Breedte': w + ' cm', 'Hoogte': h + ' cm', 'Richtprijs': '€' + result.total.toLocaleString('nl-NL'), 'Tarief': '€' + result.ratePerM2.toLocaleString('nl-NL') + '/m²' } }] })
        }).then(() => {
          if (spinner) spinner.style.display = 'none';
          this._closeSlider();
          document.dispatchEvent(new CustomEvent('updateCart', { bubbles: true }));
        }).catch(() => { if (spinner) spinner.style.display = 'none'; });
        return;
      }

      if (this.selectedIsStatic) {
        // ── Open request form panel ──
        if (spinner) spinner.style.display = 'none';
        this._openRequestForm(this.selectedSize, this.selectedPrice);

      } else {
        // ── Add real variant to cart ──
        const variantId = this.selectedVariantId || this.atcBtn.getAttribute('data-varid');
        if (!variantId || variantId.startsWith('static')) {
          if (spinner) spinner.style.display = 'none';
          return;
        }
        try {
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          });
          if (spinner) spinner.style.display = 'none';
          this._closeSlider();
          document.dispatchEvent(new CustomEvent('updateCart', { bubbles: true }));
        } catch(err) {
          if (spinner) spinner.style.display = 'none';
          console.error('Cart error:', err);
        }
      }
    });
  }

  _openRequestForm(size, price) {
    const panel   = this.querySelector('#WI_req_form_panel');
    const sizeEl  = this.querySelector('#WI_req_selected_size');
    const backBtn = this.querySelector('#WI_req_form_back');
    const submit  = this.querySelector('#WI_req_submit');
    const success = this.querySelector('#WI_req_success');
    if (!panel) return;

    // Show selected size in header
    if (sizeEl) sizeEl.textContent = size + ' — €' + price;

    // Reset form
    ['#WI_req_name','#WI_req_email','#WI_req_phone','#WI_req_notes'].forEach(id => {
      const el = this.querySelector(id);
      if (el) el.value = '';
    });
    if (success) success.style.display = 'none';
    if (submit) { submit.disabled = false; submit.textContent = 'Aanvraag versturen'; }

    // Slide in
    panel.style.transform = 'translateX(0)';

    // Back button
    backBtn?.addEventListener('click', () => {
      panel.style.transform = 'translateX(100%)';
    }, { once: true });

    // Close all button
    const closeAllBtn = this.querySelector('#WI_req_close_all');
    closeAllBtn?.addEventListener('click', () => {
      panel.style.transform = 'translateX(100%)';
      this._closeSlider();
    }, { once: true });

    // Submit
    submit?.addEventListener('click', async () => {
      const name  = this.querySelector('#WI_req_name')?.value?.trim();
      const email = this.querySelector('#WI_req_email')?.value?.trim();
      const phone = this.querySelector('#WI_req_phone')?.value?.trim();
      const notes = this.querySelector('#WI_req_notes')?.value?.trim();
      const productTitle = this.atcBtn?.getAttribute('data-product') || document.title;

      if (!name || !email) { alert('Vul naam en e-mailadres in.'); return; }

      submit.disabled = true;
      submit.textContent = 'Verzenden...';

      const body =
        'Aanvraag maat & prijs\n\n' +
        'Product: ' + productTitle + '\n' +
        'Pagina: ' + window.location.href + '\n' +
        'Geselecteerde maat: ' + size + '\n' +
        'Richtprijs: €' + price + '\n' +
        (phone ? 'Telefoon: ' + phone + '\n' : '') +
        (notes ? 'Opmerkingen: ' + notes + '\n' : '') +
        '\nNaam: ' + name + '\nE-mail: ' + email;

      const params = new URLSearchParams();
      params.append('form_type', 'contact');
      params.append('utf8', '✓');
      params.append('contact[email]', email);
      params.append('contact[name]', name);
      params.append('contact[body]', body);

      try {
        const res = await fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
          body: params.toString()
        });
        if (success) success.style.display = 'block';
        submit.textContent = '✓ Verzonden';
        setTimeout(() => {
          panel.style.transform = 'translateX(100%)';
          this._closeSlider();
        }, 2000);
      } catch(err) {
        submit.disabled = false;
        submit.textContent = 'Fout — probeer opnieuw';
        setTimeout(() => { submit.textContent = 'Aanvraag versturen'; }, 2000);
      }
    }, { once: true });
  }

  _showMessage(msg) {
    let el = this.querySelector('.WI_cal_success_msg');
    if (!el) {
      el = document.createElement('div');
      el.className = 'WI_cal_success_msg';
      el.style.cssText = 'padding:12px 20px;background:#f6f2e9;font-size:14px;color:#555;text-align:center;border-top:1px solid #eee;';
      this.querySelector('.WI_cal_in_footer').prepend(el);
    }
    el.textContent = msg;
    el.style.display = 'block';
  }

  _formatMoney(cents) {
    if (!cents || cents <= 0) return '—';
    const euros = Math.round(cents / 100);
    return '€' + euros.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  _closeSlider() {
    this.varIn.classList.remove('WI_cal_in_active');
    setTimeout(() => {
      this.varMain.style.display = 'none';
      document.dispatchEvent(new CustomEvent('close:background', { bubbles: true }));
    }, 200);
  }

  _calcCustomPrice(w, h, shapeKey = 'rechthoek') {
    const pricePerM2 = (window.WI_PRICE_PER_M2_CENTS || 0) / 100;
    if (!pricePerM2 || !w || !h) return null;
    const wNum = parseFloat(w);
    const hNum = parseFloat(h);
    if (isNaN(wNum) || isNaN(hNum) || wNum <= 0 || hNum <= 0) return null;

    const minDim = Math.min(wNum, hNum);
    const maxDim = Math.max(wNum, hNum);
    if (minDim < 90 || maxDim < 150) return { error: 'min' };
    if (maxDim > 1450 || minDim > 1050) return { error: 'max' };

    let rate;
    let isStandard = false;
    if (shapeKey === 'rechthoek') {
      const STANDARD = [[200,150],[250,200],[300,200],[300,250],[350,250],[400,300]];
      isStandard = STANDARD.some(([sw,sh]) =>
        (wNum === sw && hNum === sh) || (wNum === sh && hNum === sw)
      );
      rate = isStandard ? Math.round(pricePerM2) : Math.round(pricePerM2 * 1.10);
    } else {
      rate = Math.round(pricePerM2 * 1.10);
    }
    const areaM2 = (wNum / 100) * (hNum / 100);
    const total = Math.ceil(Math.floor(areaM2 * rate) / 5) * 5;
    return { total, ratePerM2: rate, isStandard, error: null };
  }

  setupAndersForm() {
    const submitBtn = this.querySelector('#WI_anders_submit');
    if (!submitBtn) return;

    submitBtn.addEventListener('click', async () => {
      const andersPanel = this.querySelector('#WI_anders_panel');
      const desc    = andersPanel?.querySelector('#WI_anders_desc')?.value?.trim();
      const email   = andersPanel?.querySelector('#WI_anders_email')?.value?.trim();
      const phone   = andersPanel?.querySelector('#WI_anders_phone')?.value?.trim();
      const successEl = andersPanel?.querySelector('#WI_anders_success');
      const validationMsg = submitBtn.dataset.validationMsg || 'Please fill in all required fields.';

      if (!desc || !email) { alert(validationMsg); return; }

      const origText = submitBtn.dataset.defaultText || submitBtn.textContent.trim();
      submitBtn.disabled = true;
      submitBtn.textContent = '...';

      const productTitle = this.atcBtn?.getAttribute('data-product') || document.title;
      const body =
        'Maatwerk tapijt - aangepaste vorm\n\n' +
        'Product: ' + productTitle + '\n' +
        'Pagina: ' + window.location.href + '\n' +
        'Gewenste vorm: ' + desc + '\n' +
        (phone ? 'Telefoon: ' + phone + '\n' : '');

      const params = new URLSearchParams();
      params.append('form_type', 'contact');
      params.append('utf8', '✓');
      params.append('contact[email]', email);
      params.append('contact[body]', body);

      try {
        await fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
          body: params.toString()
        });
        if (successEl) successEl.style.display = 'block';
        submitBtn.textContent = '✓';
        setTimeout(() => this._closeSlider(), 2500);
      } catch(err) {
        submitBtn.disabled = false;
        submitBtn.textContent = origText;
      }
    });
  }

  openCustomSizeSlider() {
    const opener = this.querySelector('.WI_variant_group_customBtn');
    opener?.addEventListener('click', () => {
      this.querySelector('.WI_cal_in_body').scrollTop = 0;
      this.querySelector('.WI_variant_group_customCal').style.transform = 'translateX(0)';
      if (this.priceEl) this.priceEl.textContent = '—';
      this.custCal = true;
      if (this.atcBtn) { this.atcBtn.disabled = true; const s = this.atcBtn.querySelector('span'); if (s) s.textContent = 'Voer afmetingen in'; else this.atcBtn.firstChild.textContent = 'Voer afmetingen in'; }
      // Reset inputs en foutmelding bij elke opening
      const cwEl = this.querySelector('#WI_cw');
      const chEl = this.querySelector('#WI_ch');
      if (cwEl) cwEl.value = '';
      if (chEl) chEl.value = '';
      const preview = this.querySelector('#WI_custom_price_preview');
      const errorEl = this.querySelector('#WI_custom_dim_error');
      if (preview) preview.style.display = 'none';
      if (errorEl) errorEl.style.display = 'none';
      // Reset vorm naar Rechthoek
      this.querySelector('#WI_custom_shape_row')?.querySelectorAll('.WI_custom_shape_btn').forEach(b => {
        b.classList.toggle('WI_cs_active', b.dataset.shape === 'rechthoek');
      });
      const otherFieldReset = this.querySelector('#WI_custom_shape_other_field');
      if (otherFieldReset) otherFieldReset.style.display = 'none';
      const andersPanelReset = this.querySelector('#WI_anders_panel');
      if (andersPanelReset) {
        andersPanelReset.style.display = 'none';
        const descEl = andersPanelReset.querySelector('#WI_anders_desc');
        const emailEl = andersPanelReset.querySelector('#WI_anders_email');
        const phoneEl = andersPanelReset.querySelector('#WI_anders_phone');
        const successEl = andersPanelReset.querySelector('#WI_anders_success');
        const submitEl = andersPanelReset.querySelector('#WI_anders_submit');
        if (descEl) descEl.value = '';
        if (emailEl) emailEl.value = '';
        if (phoneEl) phoneEl.value = '';
        if (successEl) successEl.style.display = 'none';
        if (submitEl) { submitEl.disabled = false; submitEl.textContent = submitEl.dataset.defaultText || submitEl.textContent; }
      }
      const dimensionsReset = this.querySelector('.WI_custom_dimensions');
      if (dimensionsReset) dimensionsReset.style.display = '';
      const infoBlockReset = this.querySelector('.WI_custom_info_block');
      if (infoBlockReset) infoBlockReset.style.display = '';
      const footerReset = this.querySelector('.WI_cal_in_footer');
      if (footerReset) footerReset.style.display = '';
      const cwLabelReset = this.querySelector('#WI_cw_label');
      if (cwLabelReset) cwLabelReset.textContent = 'Breedte';
      const chFieldReset = this.querySelector('#WI_ch_field');
      const dimSepReset = this.querySelector('#WI_custom_dim_sep');
      if (chFieldReset) chFieldReset.style.display = '';
      if (dimSepReset) dimSepReset.style.display = '';
    });

    // Shape knoppen in custom form
    const shapeRow = this.querySelector('#WI_custom_shape_row');
    shapeRow?.querySelectorAll('.WI_custom_shape_btn').forEach(btn => {
      btn.addEventListener('click', () => {
        shapeRow.querySelectorAll('.WI_custom_shape_btn').forEach(b => b.classList.remove('WI_cs_active'));
        btn.classList.add('WI_cs_active');
        const shape = btn.dataset.shape;
        const andersPanel = this.querySelector('#WI_anders_panel');
        const dimensions = this.querySelector('.WI_custom_dimensions');
        const infoBlock = this.querySelector('.WI_custom_info_block');
        const footer = this.querySelector('.WI_cal_in_footer');

        if (shape === 'anders') {
          if (andersPanel) {
            andersPanel.style.display = '';
            const descEl = andersPanel.querySelector('#WI_anders_desc');
            const emailEl = andersPanel.querySelector('#WI_anders_email');
            const phoneEl = andersPanel.querySelector('#WI_anders_phone');
            const successEl = andersPanel.querySelector('#WI_anders_success');
            const submitEl = andersPanel.querySelector('#WI_anders_submit');
            if (descEl) descEl.value = '';
            if (emailEl) emailEl.value = '';
            if (phoneEl) phoneEl.value = '';
            if (successEl) successEl.style.display = 'none';
            if (submitEl) { submitEl.disabled = false; submitEl.textContent = submitEl.dataset.defaultText || submitEl.textContent; }
          }
          if (dimensions) dimensions.style.display = 'none';
          if (infoBlock) infoBlock.style.display = 'none';
          if (footer) footer.style.display = 'none';
        } else {
          if (andersPanel) andersPanel.style.display = 'none';
          if (dimensions) dimensions.style.display = '';
          if (infoBlock) infoBlock.style.display = '';
          if (footer) footer.style.display = '';
          const cwLabel = this.querySelector('#WI_cw_label');
          const chField = this.querySelector('#WI_ch_field');
          const dimSep = this.querySelector('#WI_custom_dim_sep');
          if (shape === 'rond') {
            if (cwLabel) cwLabel.textContent = 'Diameter';
            if (chField) chField.style.display = 'none';
            if (dimSep) dimSep.style.display = 'none';
          } else {
            if (cwLabel) cwLabel.textContent = cwLabel.dataset.labelDefault || cwLabel.textContent;
            if (chField) chField.style.display = '';
            if (dimSep) dimSep.style.display = '';
          }
          updateCustomPrice();
        }
      });
    });

    // Placeholder verdwijnt direct bij klikken, komt terug als veld leeg blijft
    [{id: '#WI_cw', ph: '200'}, {id: '#WI_ch', ph: '300'}].forEach(({id, ph}) => {
      const el = this.querySelector(id);
      if (!el) return;
      el.addEventListener('focus', function() { this.placeholder = ''; this.select(); });
      el.addEventListener('blur',  function() { if (!this.value) this.placeholder = ph; });
    });

    // Live prijsberekening bij invoer afmetingen
    const updateCustomPrice = () => {
      const w = this.querySelector('#WI_cw')?.value;
      const activeShapeBtn = this.querySelector('#WI_custom_shape_row .WI_cs_active');
      const shapeKey = activeShapeBtn?.dataset.shape || 'rechthoek';
      const h = shapeKey === 'rond' ? w : this.querySelector('#WI_ch')?.value;
      const preview  = this.querySelector('#WI_custom_price_preview');
      const errorEl  = this.querySelector('#WI_custom_dim_error');
      const result   = this._calcCustomPrice(w, h, shapeKey);

      // Reset
      if (errorEl) errorEl.style.display = 'none';
      if (preview) preview.style.display = 'none';

      if (result && result.error) {
        // Buiten bereik — toon foutmelding, grijze knop
        if (errorEl) {
          errorEl.textContent = result.error === 'min'
            ? 'Minimale afmeting is 150 × 90 cm.'
            : 'Maximale afmeting is 1450 × 1050 cm.';
          errorEl.style.display = 'block';
        }
        if (this.priceEl) this.priceEl.textContent = '—';
        if (this.atcBtn) {
          this.atcBtn.disabled = true;
          const s = this.atcBtn.querySelector('span');
          if (s) s.textContent = 'Afmeting buiten bereik';
          else this.atcBtn.firstChild.textContent = 'Afmeting buiten bereik';
        }
      } else if (result && result.total > 0) {
        // Geldige maat
        if (preview) {
          const rateStr = '€' + result.ratePerM2.toLocaleString('nl-NL') + '/m²';
          const suffix = result.isStandard ? rateStr + ', standaardmaat' : rateStr;
          preview.textContent = 'Prijs: €' + result.total.toLocaleString('nl-NL') + ' (' + suffix + ')';
          preview.style.display = 'block';
        }
        if (this.priceEl) this.priceEl.textContent = 'Vanaf €' + result.total.toLocaleString('nl-NL');
        if (this.atcBtn) {
          this.atcBtn.disabled = false;
          const s = this.atcBtn.querySelector('span');
          if (s) s.textContent = 'Toevoegen aan winkelwagen';
          else this.atcBtn.firstChild.textContent = 'Toevoegen aan winkelwagen';
        }
      } else {
        // Nog geen invoer
        if (this.priceEl) this.priceEl.textContent = '—';
        if (this.atcBtn) {
          this.atcBtn.disabled = true;
          const s = this.atcBtn.querySelector('span');
          if (s) s.textContent = 'Voer afmetingen in';
          else this.atcBtn.firstChild.textContent = 'Voer afmetingen in';
        }
      }
    };
    this.querySelector('#WI_cw')?.addEventListener('input', updateCustomPrice);
    this.querySelector('#WI_ch')?.addEventListener('input', updateCustomPrice);
  }

  closeCustomSizeSlider() {
    const close = this.querySelector('.WI_variant_group_customCal_head_cls');
    close?.addEventListener('click', () => {
      this.querySelector('.WI_cal_in_body').scrollTop = 0;
      this.querySelector('.WI_variant_group_customCal').style.transform = 'translateX(100%)';
      this.custCal = false;
      // Reset knop naar standaard staat
      if (this.atcBtn) {
        this.atcBtn.disabled = true;
        const s = this.atcBtn.querySelector('span');
        const txt = this.atcBtn.dataset.defaultText || 'Toevoegen aan winkelwagen';
        if (s) s.textContent = txt; else this.atcBtn.firstChild.textContent = txt;
      }
      if (this.priceEl) this.priceEl.textContent = '—';
    });
  }

  openVarSlider() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wi-open-slider], .WI_variantOpner');
      if (!btn) return;
      document.dispatchEvent(new CustomEvent('open:background', { bubbles: true }));
      this.varMain.style.display = 'flex';
      const msg = this.querySelector('.WI_cal_success_msg');
      if (msg) msg.style.display = 'none';
      requestAnimationFrame(() => this.varIn?.classList.add('WI_cal_in_active'));
    }, true);
  }

  closeVarSlider() {
    this.varClose?.addEventListener('click', () => this._closeSlider());
    this.varMain.addEventListener('click', (e) => {
      if (e.target === this.varMain) this._closeSlider();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.varMain.style.display !== 'none') this._closeSlider();
    });
  }
}

customElements.define('wi-custom-var', WIvariantslider);
